import { IAnnex, ISocial } from '@libs/models/models';
import { NavItem } from '@libs/models/nav-item.interface';

export const websiteItems: NavItem[] = [
  {
    label: 'NAVIGATION.HOW_GET_LOAN',
    route: '/borrow',
  },
  {
    label: 'NAVIGATION.HOW_PAY_LOAN',
    route: '/repay',
  },
  {
    label: 'NAVIGATION.CONTACTS',
    route: '/contacts',
  },
  {
    label: 'NAVIGATION.ABOUT_US',
    route: '/about-us',
  },
  {
    label: 'NAVIGATION.COOPERATION',
    route: '/cooperation',
  },
];

export const socialMedia: ISocial[] = [
  {
    href: '',
    alt: 'facebook',
    img: 'assets/images/landing/icons/social-network.svg',
  },
  {
    href: '',
    alt: 'instagram',
    img: 'assets/images/landing/icons/social-network.svg',
  },
  {
    href: '',
    alt: 'telegram',
    img: 'assets/images/landing/icons/social-network.svg',
  },
];

export const annexItems: IAnnex[] = [
  {
    label: 'FOOTER.ANNEX.APP_STORE',
    link: '',
    icon: 'assets/images/icons/icon-apple.png',
  },
  {
    label: 'FOOTER.ANNEX.PAY_STORE',
    link: '',
    icon: 'assets/images/icons/icon-playmarket.png',
  },
];
